export const solarImageName = image => typeof image === 'string' ? image : image?.imageName || image?.image_name || image?.name || '';

const stem = image => solarImageName(image).split(/[\\/]/).pop().replace(/\.[^.]+$/, '').toLowerCase();

export const isSolarThermalImage = image => /_t$/i.test(stem(image));

// Only pair an unambiguous capture name. Do not guess from ordering or proximity.
export function matchingRgbImage(thermal, images) {
  if (!isSolarThermalImage(thermal)) return null;
  const key = stem(thermal).replace(/_t$/, '_v');
  const matches = images.filter(image => stem(image) === key);
  return matches.length === 1 ? matches[0] : null;
}
